import React, { PureComponent, useEffect } from 'react';
import { Button, Card, Col, Container, Image, Row } from 'react-bootstrap';
import ConstAnalysisAdvicePieChart from './ConstAnalysisAdvicePieChart';
import DataTableComponent from '../../dataTables/dataTable';

const ConsAnalysisAdvice = (props) => {

    useEffect(() => {
        if (props.tableData) {
            console.log('ConsAnalysisAdvice props', props);
        }
    }, [props]);

    return (
        <div className='cons-analysis-advice-screen transition'>

            <Container>
                <Row>

                    {/* LEFT BOX */}
                    <Col lg='6' md='12' className='left-box-col transition' >
                        <label className='roboto-bold-16 color-text'>
                            Yerli Analist Tavsiye Dağılımı
                        </label>
                        <div className='cons-analysis-advice-box'>
                            <ConstAnalysisAdvicePieChart chartData={props.pieChartData} />
                        </div>
                    </Col>
                    {/* LEFT BOX */}

                    {/* RIGHT BOX */}
                    <Col lg='6' md='12' className='right-box-col  transition'>
                        <label className='roboto-bold-16 color-text'>
                            Açıklanan Karlar ve Analist Beklentileri (mn.)
                        </label>
                        <div className='cons-analysis-advice-box'>
                            <DataTableComponent columnsProp={props.colums} dataProp={props.tableData} />
                        </div>
                    </Col>
                    {/* RIGHT BOX */}
                </Row>

            </Container>
        </div>
    );
}

export default ConsAnalysisAdvice;
